import { useEffect } from 'react';

import { datadogRum } from '@datadog/browser-rum';

import { uiRoutes } from '@consumer-frontend/nc-api';
import { Container, Link } from '@consumer-frontend/shared-ui';

import '@consumer-bootstrap/netcredit.scss';

export const NcRequestCashAdvanceConfirmationPage: React.FC = () => {
  useEffect(
    () => { datadogRum.addAction('NcRequestCashAdvanceConfirmationPageView'); },
    [],
  );

  return (
    <Container>
      <h1 className="h3">Cash Advance Confirmation</h1>

      <Link to={uiRoutes.dashboard.requestCashAdvanceReview}>
        Back to Review
      </Link>
    </Container>
  );
};
